
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Our Events</h1>
				</div>
			</div>
		</div>
	</div>
	<div class="breadcrumb-bottom-img">
		<img
			src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
	</div>
</section>
<section class="section section-sm events section-banner-bg-1">
	<div class="container">

		<div class="text-center sec-title mb-md-5">
			<h2><span>G H RAISONI SPORTS & CULTURAL FOUNDATION</span></h2>
      <p class="text-center">GHRSCF will embrace the benefits of Culture and Sport, recreation and fitness in building a healthy community
			and developing lifelong connections to the Society, Students and will support the provision of quality
			facilities and programmes.</p>

		</div>

		<div class="row justify-content-center row-cols-1 row-cols-lg-2 align-items-center mt-3">
			<div class="col">
				<div class="hovereffect hovereffect_div">
					<img class="img-fluid"
						src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sport.jpg" alt="GHRSCF">
					<div class="overlay">
						<h2>Sports Events</h2>
						<div class="text-center position-relative">
							<a routerLink="/sport-events" class="cmn-button" >View More</a>

						</div>
					</div>
				</div>
			</div>
			<div class="col">
				<div class="hovereffect hovereffect_div">
					<img class="img-fluid"
						src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/culture.jpg" alt="GHRSCF">
					<div class="overlay">
						<h2>Cultural Events</h2>
						<div class="text-center position-relative">
							<a routerLink="/cultural-events" class="cmn-button" >View More</a>

						</div>
					</div>
				</div>
			</div>
			<div class="col">
				<div class="hovereffect hovereffect_div">
					<img class="img-fluid" src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/extended-support/support.webp" alt="GHRSCF">
					<div class="overlay">
						<h2>Extended support</h2>
						<div class="text-center position-relative">
							<a routerLink="/extended-support" class="cmn-button" >View More</a>
						</div>
					</div>
				</div>
			</div>
			<div class="col">
				<div class="hovereffect hovereffect_div">
					<img class="img-fluid" src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/support-encouragement/support-%26encouragement.webp" alt="GHRSCF">
					<div class="overlay">
						<h2>Support & Encouragement</h2>
						<div class="text-center position-relative">
							<a routerLink="/support-encouragement" class="cmn-button" >View More</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
